const styles = {
    termsContainer: {
        maxWidth: '600px',
        display: 'inline-flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        fontSize: '0.85rem',
        padding: '0 25px',
        margin: '15px',
        '@media (max-width: 600px)': {
            padding: '0 15px',
        },
    },
    termsText: {
        fontWeight: 'bold',
        textAlign: 'center',
    },
    termsLink: {
        textDecoration: 'underline',
    },
};

export default styles;